import { type ReactNode } from 'react';
import { LegalSectionView, type LegalSection } from './legal-section';
import { PRIVACY_CONTROLLER } from './privacy-data-controller';
import { PRIVACY_RIGHTS } from './privacy-data-rights';
import { PRIVACY_MISC } from './privacy-data-misc';

const SECTIONS: readonly LegalSection[] = [
  ...PRIVACY_CONTROLLER,
  ...PRIVACY_RIGHTS,
  ...PRIVACY_MISC,
];

function Intro(): ReactNode {
  return (
    <p className="mb-lg text-xs leading-relaxed text-text-tertiary">
      Esta Política de Privacidad describe cómo Debook trata los datos
      personales de los Collectors y creadores de Instagram cuyos perfiles
      públicos se recopilan. Para consultas, contacte a support@debook.app.
    </p>
  );
}

export function PrivacyPolicyContent(): ReactNode {
  return (
    <div>
      <Intro />
      {SECTIONS.map((s) => (
        <LegalSectionView key={s.title} section={s} />
      ))}
    </div>
  );
}
